"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//  // otro modulito
const toKebabCase = (entry = '') => {
    let kebapName = entry
        .replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2')
        .toLowerCase();
    if (kebapName[0] === '-') {
        kebapName = kebapName.substr(1);
    }
    return kebapName;
};
exports.default = toKebabCase;
//# sourceMappingURL=index.js.map